import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lkd-form',
  templateUrl: './form.component.html',
  styles: []
})
export class FormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
